export default "__VITE_ASSET__$PNxuMIp__"